module.exports = __webpack_public_path__ + "img/logo_uplaw_signet.0aeb51b5.png";